import React from "react";
import i18next from "../localization/i18n";
import MapIcon from "@mui/icons-material/Map";
import SaitRowAction from "./SaitRowAction";
import { saitfecoreNs } from "../utils/Constants";

/*
	Obbligatori:
		id
		onClick
	Facoltativi:
*/

export default function SaitRowActionMaps(props) {
	return SaitRowAction({
		id: props.id,
		icon: <MapIcon color="success" />,
		tooltip: i18next.t("open_directions", { ns: saitfecoreNs }),
		onClick: (params) => {
			window.open("https://maps.google.it?q=" + props.address(params));
		},
		conditionalRendering: (params) => {
			return props.address(params);
		},
		roleSecurity: props.roleSecurity,
		objmod: props.objmod,
		hidden: props.hidden,
	});
}
